'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _passwordValidator = require('../util/passwordValidator');

var _passwordValidator2 = _interopRequireDefault(_passwordValidator);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                  * This component is awfully similar to CreateAccountPost, but with some interesting use case differences.
                                                                                                                                                                                                                  *
                                                                                                                                                                                                                  * Namely, this component is planned to be used amongst other fields (and won't have it's own submit button), AND these fields
                                                                                                                                                                                                                  * don't have to be completed. As a result, it will look to this.props.showValidation to determine if errors should actually be shown (if the user clicks
                                                                                                                                                                                                                  * some other submit with invalid details, for example). This component keeps track of what is wrong, the consumer of the component determines if it's a good time to show the errors.
                                                                                                                                                                                                                  *
                                                                                                                                                                                                                  * Also, because it's not (always ** read last paragraph **) necessary for the consumer to worry about this component's validation (if a user chooses not to create an account),
                                                                                                                                                                                                                  * this component will call this.props.handleCreateAccountCheckbox with a boolean designating the user's intent to do so and that the consumer must now
                                                                                                                                                                                                                  * wait for valid password info before proceeding.
                                                                                                                                                                                                                  *
                                                                                                                                                                                                                  * Lastly, this component will assess the validation of the content in its fields every time state or props are updated.
                                                                                                                                                                                                                  * If all of the content is valid at any point it will fire this.props.handleValidInfo() which will allow the consumer to know
                                                                                                                                                                                                                  * the chosen password — and implicitly — that this part of the form is completed. (We'll also call resetValidInfo() if this is ever made untrue again.)
                                                                                                                                                                                                                  *
                                                                                                                                                                                                                  * If this component is used with 'mandatory' prop set to 'true', the optional checkbox will be hidden, and the password inputs will be visible always.
                                                                                                                                                                                                                  * Additionally, the this.props.handleCreateAccountCheckbox will not be called, because the consumer should assume that they should wait for
                                                                                                                                                                                                                  * this.props.handleValidInfo() to show that the user successfully completed the, now mandatory, password selection.
                                                                                                                                                                                                                  * */

var styles = _aphrodite.StyleSheet.create({
	mainTitle: {
		marginBottom: '10px'
	},
	mainBlurb: {
		marginBottom: '15px'
	},
	itsFreeLine: {
		margin: '30px 0 15px 0'
	},
	shiftRight: {
		marginLeft: '30px'
	},
	hide: {
		display: 'none'
	},
	createAccountCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline'
	},
	createAccountCheckbox: {
		':before': {
			overflow: 'hidden',
			border: '1px solid #9b9b9b'
		}
	},
	createAccountLine: {
		marginLeft: '40px'
	},
	passwordWarningWrapper: {
		background: '#fff7f7',
		padding: '10px 10px 5px',
		borderRadius: 5,
		border: '1px solid #c72e2e',
		marginTop: 15
	},
	passwordWarningItem: {
		margin: 0,
		paddingBottom: 5
	},
	legalWrapper: {
		marginTop: '20px',
		position: 'relative'
	},
	legalCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline'
	},
	legalCheckbox: {
		':before': {
			overflow: 'hidden',
			border: '1px solid #9b9b9b'
		}
	},
	redBorder: {
		':before': {
			background: '#fff7f7',
			border: '1px solid #c72e2e'
		}
	},
	legalBlurb: {
		lineHeight: '18px',
		marginLeft: '45px'
	},
	button: {
		display: 'block',
		margin: '40px auto 0'
	},
	passwordWrapper: {
		marginBottom: '10px'
	}
});

var CreateAccountPre = _react2.default.createClass({
	displayName: 'CreateAccountPre',

	propTypes: {
		mainTitle: _react.PropTypes.string.isRequired,
		mainBlurb: _react.PropTypes.string.isRequired,
		legalBlurbHTML: _react.PropTypes.string.isRequired,
		handleValidInfo: _react.PropTypes.func.isRequired,
		resetValidInfo: _react.PropTypes.func.isRequired,
		showValidationErrors: _react.PropTypes.bool.isRequired,
		itsFreeLine: _react.PropTypes.string,
		label1: _react.PropTypes.string,
		label2: _react.PropTypes.string,
		handleCreateAccountCheckbox: _react.PropTypes.func,
		mandatory: _react.PropTypes.bool,
		passwordWarnings: _react.PropTypes.shape({
			_MISMATCH: _react.PropTypes.string.isRequired,
			_IS_NULL: _react.PropTypes.string.isRequired,
			_TOO_SHORT: _react.PropTypes.string.isRequired,
			_TOO_LONG: _react.PropTypes.string.isRequired,
			_CONTAINS_REPEATED_CHARACTERS: _react.PropTypes.string.isRequired,
			_CONTAINS_NUMBER_SEQUENCE: _react.PropTypes.string.isRequired,
			_CONTAINS_LETTER_SEQUENCE: _react.PropTypes.string.isRequired,
			_CONTAINS_NUMBER_LETTER_SEQUENCE: _react.PropTypes.string.isRequired,
			_IS_BLACKLISTED: _react.PropTypes.string.isRequired,
			_CONTAINS_SPACES: _react.PropTypes.string.isRequired,
			_HAS_ILLEGAL_CHARACTERS: _react.PropTypes.string.isRequired,
			_LEGAL_CHECKBOX: _react.PropTypes.string.isRequired
		}).isRequired
	},

	getInitialState: function getInitialState() {
		return {
			showCreateAccountFields: false,
			password1: '',
			password2: '',
			acceptedLegal: false,
			passwordErrors: []
		};
	},


	// every time the component updates, should check for valid info to fire to parent
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// If someone where calling setState (or anything prompting rerender) within this.props.handleValidInfo or this.props.resetValidInfo
		// it would cause an infinite loop (component would rerender, passwords would still be valid, etc.).
		// This outer `if` statement checks that the password or checkbox has changed before calling the parent method.
		if (prevState.password1 !== this.state.password1 || prevState.password2 !== this.state.password2 || prevState.acceptedLegal !== this.state.acceptedLegal) {
			var passwordErrors = (0, _passwordValidator2.default)(this.state.password1);
			// if the passwords match, have no error, and the user has accepted the legal agreement...
			if (this.doPasswordsMatch() && !passwordErrors.length && this.state.acceptedLegal) {
				// call the prop function that signifies to the parent that everything is ready to go!
				this.props.handleValidInfo(this.state.password1);
			} else {
				// This covers the scenario where a user has valid information, but goes back and changes things to be invalid later
				// consumers need to know to clear the initial valid information from their stores.
				this.props.resetValidInfo();
			}
		}
	},


	// in the case that the user fills nothing out after ticking the create account box
	// we need to show password validation errors for empty password fields
	componentWillReceiveProps: function componentWillReceiveProps() {
		this.setState({
			passwordErrors: (0, _passwordValidator2.default)(this.state.password1)
		});
	},
	handleCreateAccountCheckbox: function handleCreateAccountCheckbox(event) {
		this.props.handleCreateAccountCheckbox(event.target.checked);
		this.setState({
			showCreateAccountFields: event.target.checked
		});
	},
	handleUpdatePasswords: function handleUpdatePasswords(password, whichInput) {
		var _newState;

		var newState = (_newState = {}, _defineProperty(_newState, whichInput, password), _defineProperty(_newState, 'passwordErrors', whichInput === 'password1' ? (0, _passwordValidator2.default)(password) : this.state.passwordErrors), _newState);
		this.setState(newState);
		return password; // returning for TextInput https://github.paypal.com/react/react-text-input
	},
	handleLegalCheckbox: function handleLegalCheckbox(event) {
		this.setState({
			acceptedLegal: event.target.checked
		});
	},


	/**
  * check that the two passwords within state are matching
  * @return {boolean}
  */
	doPasswordsMatch: function doPasswordsMatch() {
		return this.state.password1 === this.state.password2;
	},
	renderPasswordErrors: function renderPasswordErrors() {
		var _this = this;

		return _react2.default.createElement(
			'span',
			null,
			!this.doPasswordsMatch() && _react2.default.createElement(
				'p',
				{ className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
				this.props.passwordWarnings._MISMATCH
			),
			this.state.passwordErrors.map(function (code) {
				var warningMessage = _this.props.passwordWarnings[code];
				return _react2.default.createElement(
					'p',
					{ key: code, className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
					warningMessage
				);
			})
		);
	},
	render: function render() {
		var _this2 = this;

		var _state = this.state;
		var acceptedLegal = _state.acceptedLegal;
		var passwordErrors = _state.passwordErrors;
		var showValidationErrors = this.props.showValidationErrors;

		var passwordErrorsExist = !this.doPasswordsMatch() || !!passwordErrors.length;
		var shouldShowErrorMessages = showValidationErrors && (passwordErrorsExist || !acceptedLegal);

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'h2',
				{ className: (0, _aphrodite.css)(styles.mainTitle) },
				this.props.mainTitle
			),
			_react2.default.createElement(
				'p',
				{ className: (0, _aphrodite.css)(styles.mainBlurb) },
				this.props.mainBlurb
			),
			!this.props.mandatory && // if the password is optional — show the optional checkbox
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					'p',
					{ className: (0, _aphrodite.css)(styles.itsFreeLine) + ' vx_text-5' },
					this.props.itsFreeLine
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.createAccountCheckboxWrapper)) },
					_react2.default.createElement('input', {
						onChange: this.handleCreateAccountCheckbox,
						type: 'checkbox', id: 'createAccountCheckbox' }),
					_react2.default.createElement('label', { htmlFor: 'createAccountCheckbox', className: (0, _aphrodite.css)(styles.createAccountCheckbox) })
				),
				_react2.default.createElement(
					'p',
					{ className: (0, _aphrodite.css)(styles.createAccountLine) },
					'Yes, I want a PayPal account.'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: (0, _aphrodite.css)(!this.props.mandatory && styles.shiftRight, !this.props.mandatory && !this.state.showCreateAccountFields && styles.hide) },
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
					_react2.default.createElement(_reactTextInput2.default, {
						className: 'vx_form-control vx_form-control_complex',
						label: this.props.label1,
						name: 'password1',
						type: 'password',
						id: 'test_input1',
						handleChange: function handleChange(password) {
							return _this2.handleUpdatePasswords(password, 'password1');
						}
					})
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
					_react2.default.createElement(_reactTextInput2.default, {
						className: 'vx_form-control vx_form-control_complex',
						label: this.props.label2,
						name: 'password2',
						type: 'password',
						id: 'test_input2',
						handleChange: function handleChange(password) {
							return _this2.handleUpdatePasswords(password, 'password2');
						}
					})
				),
				shouldShowErrorMessages && _react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(styles.passwordWarningWrapper) },
					showValidationErrors && passwordErrorsExist && this.renderPasswordErrors(),
					showValidationErrors && !acceptedLegal && _react2.default.createElement(
						'p',
						{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
						this.props.passwordWarnings._LEGAL_CHECKBOX
					)
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(styles.legalWrapper) },
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.legalCheckboxWrapper)) },
						_react2.default.createElement('input', {
							onChange: this.handleLegalCheckbox,
							type: 'checkbox', id: 'accountLegalCheckbox' }),
						_react2.default.createElement('label', { htmlFor: 'accountLegalCheckbox', className: (0, _aphrodite.css)(styles.legalCheckbox, showValidationErrors && !acceptedLegal && styles.redBorder) })
					),
					_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalBlurb) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.legalBlurbHTML } })
				)
			)
		);
	}
});

exports.default = CreateAccountPre;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/guest-payment/dist/components/CreateAccountPre.js
 ** module id = 336
 ** module chunks = 6
 **/